import {resource} from '@albert-io/json-api-framework/request/builder';

import masqueradeStore from 'client/generic/Masquerade/Masquerade.store';

export const getTeacherHasClassSubjects = async () => {
  const classrooms = await resource('classrooms_v1')
    .mandarkEndpoint(['teachers_v1', masqueradeStore.getUserIdByMasqueradeState(), 'classrooms_v1'])
    .filter({
      school_v5: masqueradeStore.getSchoolId()
    })
    .filter({
      status: 'active'
    })
    .include('subjects_v2')
    .getResourcePromise();

  return classrooms.some((classroom) => !classroom.get('subjects').isEmpty());
};
